import React, { useEffect, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  AddPackageCategory,
  AddPackageStyle,
} from "../../../entities/action/action";
import PackageCategoryAndStyleList from "./packageCategoryAndStyleList";

const AddPackageCategoryAndStyleForm = (props) => {
  const userData = useSelector((state) => state.adminAccount.apiResponse);

  const [input, SetInput] = useState("");
  const [data, updateData] = useState([]);
  useEffect(() => {
    (async () => {
      if (props.categoryType == "Category") {
        const myresponse = await fetch(
          "https://api.zupptravel.com/api/v1/holiday/getHolidayCategories",
          {
            method: "get",
            headers: {
              "Content-Type": "application/json",
            }
          }
        );
        const myjson = await myresponse.json();
        console.log("MYJSON", myjson);
        if (myjson.success) {
          updateData(myjson.holidayCategories);
        }
      } else {
        const myresponse = await fetch(
          "https://api.zupptravel.com/api/v1/holiday/getHolidayStyles",
          {
            method: "get",
            headers: {
              "Content-Type": "application/json",
            }
          }
        );
        const myjson = await myresponse.json();
        console.log("MYJSON", myjson);
        if (myjson.success) {
          updateData(myjson.holidayStyles);
        }
      }
    })();
  }, []);
  const handleSubmit = async () => {
    let response;
    if (props.categoryType == "Category") {
      const newData = {
        categoryName: input,
      };

      response = await AddPackageCategory(newData);
      console.log(response);
      if (response.success) {
        alert("Successfully added package category!");
        window.location.reload();
      }
    } else {
      const newData = {
        styleName: input,
      };

      response = await AddPackageStyle(newData);
      console.log(response);
      if (response.success) {
        alert("Successfully added package style!");
        window.location.reload();
      }
    }
  };
  return (
    <div>
      <Form.Group controlId="formBasicPromo" as={Row}>
        <Form.Label column sm="3">
          Package {`${props.categoryType}`}:
        </Form.Label>
        <Col sm="9">
          <Form.Control
            type="text"
            placeholder={`Enter ${props.categoryType}`}
            name="category"
            onChange={(e) => SetInput(e.target.value)}
            value={input}
            required
          />
        </Col>
      </Form.Group>
      <center>
        <Button onClick={handleSubmit} style={{ margin: "2%" }}>
          Save Package {`${props.categoryType}`}
        </Button>
      </center>
      <PackageCategoryAndStyleList type={props.categoryType} data={data} />
    </div>
  );
};
export default AddPackageCategoryAndStyleForm;
